/**
 * billingService — checkout de planos/pacotes (Escopo 2, Modelo B).
 *
 * A API é o BFF: encaminha ao serviço Billing internamente. O front só conhece o slug do
 * plano (da vitrine) — a API resolve para id e deriva o cliente do JWT.
 *
 * Fluxo: createOrder → redireciona o navegador para checkoutUrl (gateway) → o gateway
 * volta para /billing/return?token=... → confirmOrder aplica a fulfillment síncrona.
 */
import api from './api';

const billingService = {
  /**
   * Inicia uma compra. Devolve { intentId, orderId, checkoutUrl }.
   * @param {{kind:string, planSlug?:string, planId?:string, billingCycle?:string, productId?:string, document?:string, methods?:string[], providerSlug?:string}} input
   */
  async createOrder(input) {
    const res = await api.post('/v1/billing/orders', input);
    return res.data;
  },

  /** Confirma no retorno do checkout. Devolve { billingOutcome, fulfillmentOutcome, externalRef }. */
  async confirmOrder(callbackToken) {
    const res = await api.post('/v1/billing/orders/confirm', { callbackToken });
    return res.data;
  },
};

export default billingService;
